import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { googleExchange } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const dest = location.pathname && location.pathname !== "/" ? location.pathname : "/community";
    (async () => {
      try {
        const u = await googleExchange(sid);
        toast.success(`Benvenuto, ${u.name}`);
      } catch {
        toast.error("Accesso Google non riuscito");
      }
      window.history.replaceState(null, "", dest);
      nav(dest, { replace: true });
    })();
  }, []);

  return (
    <div className="min-h-screen grain-bg flex items-center justify-center">
      <img src="/logo-mark.png" alt="" className="w-24 animate-pulse" data-testid="auth-callback-loader" />
    </div>
  );
}
